const DisplayBoxHeadingStyle = `
  border-bottom-width: 1px;
  font-size: 18px;
  font-weight: 500;
  padding: 25px 30px 15px;
`;

export default DisplayBoxHeadingStyle;
